import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import toParams from '../../helpers/to-params'

@inject("store")
@observer
export default class BookNowButton extends React.Component {
  static propTypes = {
    store: PropTypes.shape({
      franchise: PropTypes.shape({
        attributes: PropTypes.shape({
          primaryColor: PropTypes.string.isRequired,
          contrastColor: PropTypes.string.isRequired,
          bookingUrl: PropTypes.string.isRequired
        }).isRequired
      }).isRequired
    }).isRequired,
    showBookNowButton: PropTypes.bool.isRequired,
    bookNowButtonText: PropTypes.string.isRequired,
    showCustomBookingUrl: PropTypes.bool,
    customBookingUrl: PropTypes.string,
    packageGroupId: PropTypes.number,
    eventCategoryId: PropTypes.number,
    eventTypeId: PropTypes.number,
    eventDate: PropTypes.string,
    buttonBackgroundColor: PropTypes.string,
    buttonForegroundColor: PropTypes.string,
    fontFamily: PropTypes.string,
    addOnId: PropTypes.number
  }

  static defaultProps = {
    showBookNowButton: true,
    bookNowButtonText: "Book Now",
    showCustomBookingUrl: false,
    customBookingUrl: ""
  }

  state = {
    hover: false
  }

  handleMouseOver = () => {
    this.setState({ hover: true })
  }
  
  handleMouseOut = () => {
    this.setState({ hover: false })
  }

  bookingUrl() {
    const { store, showCustomBookingUrl, customBookingUrl, eventTypeId, packageGroupId, eventCategoryId, addOnId, eventDate } = this.props
    const { bookingUrl } = store.franchise.attributes

    if(showCustomBookingUrl) {
      return customBookingUrl
    }

    let args = {}
    if(eventDate) {
      args.event_date = eventDate
    }

    if(eventTypeId) {
      args.event_type_id = eventTypeId
    }
    else if(packageGroupId) {
      args.package_group_id = packageGroupId
    }
    else if(eventCategoryId) {
      args.event_category_id = eventCategoryId
    }

    if(addOnId) {
      args.add_on_ids = addOnId
    }

    return `${bookingUrl}/set_event?${toParams(args)}`
  }

  render() {
    const { store, showBookNowButton, bookNowButtonText, buttonBackgroundColor,
      buttonForegroundColor, fontFamily } = this.props
    const { primaryColor, contrastColor, bookingUrl } = store.franchise.attributes
    const { hover } = this.state

    const inactiveStyle = {
      color: buttonForegroundColor ? buttonForegroundColor : primaryColor,
      fontFamily: fontFamily ? fontFamily : "inherit",
      backgroundColor: buttonBackgroundColor ? buttonBackgroundColor : contrastColor,
      borderColor: buttonForegroundColor ? buttonForegroundColor : primaryColor,
      ...style.button
    }

    const activeStyle = {
      color: buttonBackgroundColor ? buttonBackgroundColor : contrastColor,
      fontFamily: fontFamily ? fontFamily : "inherit",
      backgroundColor: buttonForegroundColor ? buttonForegroundColor : primaryColor,
      borderColor: buttonForegroundColor ? buttonForegroundColor : primaryColor,
      ...style.button
    }

    if(!showBookNowButton) {
      return null
    }

    return (
      <a
        target="_top"
        href={this.bookingUrl()}
        className="btn btn-secondary"
        onMouseOver={this.handleMouseOver}
        onMouseOut={this.handleMouseOut}
        style={hover ? activeStyle : inactiveStyle}
      >
        { bookNowButtonText }
      </a>
    )
  }

}

const style = {
  button: {
    cursor: "pointer"
  }
}
